import colors from "../../base/colors";
import typography from "../../base/typography";
import pxToRem from "../../functions/pxToRem";

const { text, grey } = colors;
const { fontWeightRegular } = typography;

const formControlLabel = {
  styleOverrides: {
    root: {
      display: "inline-flex",
      alignItems: "center",
      minHeight: pxToRem(32),
      marginLeft: 0,
      marginRight: pxToRem(16),
      marginBottom: 0,
    },

    label: {
      display: "inline-block",
      fontSize: pxToRem(14),
      fontWeight: fontWeightRegular,
      color: text.main,
      lineHeight: 1.4,
      transform: "none",
      marginLeft: pxToRem(8),

      "&.Mui-disabled": {
        color: grey[500],
      },
    },
  },
};

export default formControlLabel;
